module.exports = __webpack_public_path__ + "img/exercise-1.26d2cca0.png";